import * as React from "react";
import { Layout, NotFound } from "../../components";
import { generatePageUrl, maybe } from "../../core/utils";
import Page from "./Page";

const canDisplay = page =>
  maybe(() => !!page && !!page.title && !!page.contentJson);

export const View: React.FC<any> = ({
  pageContext: { page, categories, suggestedPosts, tags, nextPost },
}) => {
  const [loading, setLoading] = React.useState(false);
  const breadcrumbs = [
    {
      link: generatePageUrl(page.slug),
      value: page.title,
    },
  ];

  // console.warn(redirects);

  if (canDisplay(page)) {
    return (
      <Layout
        metaTitle={page.seoTitle}
        metaDescription={page.seoTitle}
        categories={categories}
        loading={loading}
        tags={tags}
      >
        <Page
          nextPost={nextPost}
          breadcrumbs={null}
          page={page}
          categories={categories || []}
          suggestedPosts={suggestedPosts || []}
          setLoading={setLoading}
        />
      </Layout>
    );
  }

  if (page === null) {
    return (
      <Layout categories={categories} tags={tags}>
        <NotFound />
      </Layout>
    );
  }
};
export default View;
